import React, { useState } from "react";
import { Typography, Box, Grid } from "@mui/material";
import TextArea from "../../../components/common/TextArea/TextArea";
import InputBox from "../../../components/common/InputBox/InputBox";
import BNPSFormat from "./DisplayFormat/BNPSFormat";
import RatingFormat from "./Ratings";
import OptionsFormat from "./DisplayOptionFormat";
import StringToMuiTypography from "../AddQuestions/StringToMuiTypography";
import MultipleCheckbox from "./MultipleCheckbox/MultipleCheckbox";
import NpsSmileyRating from "./DisplayFormat/NpsSmileyRating";

const BDisplayQuestions = ({
  mandatoryChecked,
  question,
  shortPlaceholder,
  paraPlaceholder,
  value,
  text,
  options,
  queId,
  // index,
  // onEmailChange,
  // onNumberChange,
  selectedId,
  buttonClicked,
  questionsFontStyle,
  optionsFontStyle,
  emojiSelectedId,
  setEmojiSelectedId,
  smileySelections, //for smiley nps
  setSmileySelections,
  starSelections, //for star
  setStarSelections,
  optionsFontSize,
  errorMessage,
  formData,
  handleChange,
  mulChResponses,
  setMulChResponses,
  questionFontSize,
  handleSmileyClick,
  handleEmojiClick,
  handleStarClick,
  handleBSelect,
  selected,
  circlesOnly = false,
}) => {
  // const [email, setEmail] = useState("");
  // const [number, setNumber] = useState(0);
  let quesText = text;
  // const handleSmileyClick = (queId, val) => {
  //   setSmileySelections((prev) => ({ ...prev, [queId]: val }));
  // };
  // Star rating handling
  // const handleStarClick = (queId, val) => {
  //   // console.log(queId, val);
  //   setStarSelections((prev) => ({ ...prev, [queId]: val }));
  // };

  // Emoji rating handling
  // const handleEmojiClick = (queId, val) => {
  //   setEmojiSelectedId((prev) => ({ ...prev, [queId]: val }));
  // };

  const handleMultiChange = (optionId) => {
    setMulChResponses((prevResponses) => {
      const selectedOptions = prevResponses[question.que_pk_id] || [];
      if (selectedOptions.includes(optionId)) {
        // Remove option if it's already selected
        return {
          ...prevResponses,
          [question.que_pk_id]: selectedOptions.filter((id) => id !== optionId),
        };
      } else {
        // Add option if it's not selected
        return {
          ...prevResponses,
          [question.que_pk_id]: [...selectedOptions, optionId],
        };
      }
    });
  };

  // const handleEmail = (event) => {
  //   const emails = event.target.value;
  //   setEmail(event.target.value);
  //   onEmailChange(emails);
  // };
  // const handleNUmber = (event) => {
  //   const number = event.target.value;
  //   setNumber(event.target.value);
  //   onNumberChange(number);
  // };

  return (
    <Box mb={circlesOnly ? 0 : 2}>
      <Grid container>
        <Grid item xs={12} mt={4}>
          {text !== undefined && text !== null ? (
            <>
              <Typography
                variant="sh3"
                sx={{
                  fontFamily: "Poppins",
                  // fontFamily: questionsFontStyle,
                  // fontSize: questionFontSize ? `${questionFontSize}px` : "1.25rem",
                  fontWeight: "500",
                  color: "#333",
                  fontSize: {
                    xs: "1rem",
                    sm: "1.125rem",
                    md: "1.25rem",
                    lg: "1.375rem",
                  },
                  // mt:0.5
                }}
              >
                {/* {`Q${index}.`}&nbsp; */}
                {"Q. "}
              </Typography>
              <StringToMuiTypography
                inputString={quesText}
                questionsFontStyle={questionsFontStyle}
                questionFontSize={questionFontSize}
              />
              {mandatoryChecked === true && (
                <Typography
                  variant="body3"
                  sx={{
                    fontFamily: questionsFontStyle,
                    fontSize: {
                      xs: "1rem",
                      sm: "1.125rem",
                      md: "1.25rem",
                      lg: "1.375rem",
                    },
                    // fontSize: questionFontSize
                    //   ? `${questionFontSize}px`
                    //   : "1.25rem",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >{`*`}</Typography>
              )}
            </>
          ) : null}
        </Grid>
      </Grid>
      {text !== undefined && text !== null ? (
        value === 1 ? (
          <>
            <InputBox
              // questionsFontStyle={questionsFontStyle}
              questionsFontStyle={optionsFontStyle[1]}
              placeholder={shortPlaceholder}
              name={`shortAnswer_${question.que_pk_id}`}
              value={formData[`shortAnswer_${question.que_pk_id}`] || ""}
              onChange={handleChange}
              error={errorMessage}
            />
          </>
        ) : value === 2 ? (
          <>
            <TextArea
              // questionsFontStyle={questionsFontStyle}
              questionsFontStyle={optionsFontStyle[1]}
              rows={3}
              placeholder={paraPlaceholder}
              name={`paraAns_${question.que_pk_id}`}
              value={formData[`paraAns_${question.que_pk_id}`] || ""}
              onChange={handleChange}
              error={errorMessage}
            />
          </>
        ) : value === 3 ? (
          <>
            {question.otype_fk_id === 1 && (
              <>
                <BNPSFormat
                  selected={selected}
                  handleSelect={handleBSelect}
                  circlesOnly={circlesOnly}
                />
                {/* <NpsNumberRating /> */}
              </>
            )}
            {question.otype_fk_id === 2 && (
              <>
                <NpsSmileyRating
                  options={options}
                  onClick={(val) => handleSmileyClick(queId, val)}
                  selectedSmileyId={smileySelections[queId] || null}
                  optionsFontStyle={optionsFontStyle[1]}
                  error={errorMessage}
                />
              </>
            )}
          </>
        ) : value === 4 ? (
          <>
            <OptionsFormat //single choice
              options={options}
              type={value}
              name={`singleChoiceAns_${question.que_pk_id}`}
              value={formData[`singleChoiceAns_${question.que_pk_id}`] || ""}
              onChange={handleChange}
              optionsFontStyle={optionsFontStyle[1]}
              error={errorMessage}
            />
          </>
        ) : value === 5 ? (
          <>
            <MultipleCheckbox
              data={question}
              question={question}
              mulChResponses={mulChResponses}
              optionsFontStyle={optionsFontStyle[1]}
              setMulChResponses={setMulChResponses}
              error={errorMessage}
              handleMultiChange={handleMultiChange}
            />
          </>
        ) : value === 6 ? (
          <>
            {/* <InputBox
              type="email"
              placeholder={shortPlaceholder}
              value={email}
              onChange={handleEmail}
              error={errorMessage}
            /> */}
          </>
        ) : value === 7 ? (
          <>
            {/* <InputBox
              type="number"
              placeholder={shortPlaceholder}
              value={number}
              onChange={handleNUmber}
              error={errorMessage}
            /> */}
          </>
        ) : value === 8 ? (
          <>
            <RatingFormat
              options={options}
              ratingStyle={question.otype_fk_id}
              countValue={options.length}
              selectedId={selectedId}
              buttonClicked={buttonClicked}
              starSelectedId={starSelections[queId] || null} //star rating
              emojiSelectedId={emojiSelectedId[queId] || null} //emoji rating
              optionsFontStyle={optionsFontStyle[1]}
              onClick={(val) => handleStarClick(queId, val)} //
              handleEmojiClick={(val) => handleEmojiClick(queId, val)}
              onChange={handleChange}
              errorMessage={errorMessage}
              name={`radioRatingAns_${question.que_pk_id}`}
              value={formData[`radioRatingAns_${question.que_pk_id}`] || ""} //radio rating
            />
          </>
        ) : null
      ) : null}
    </Box>
  );
};
export default BDisplayQuestions;
